export const roleId1 = process.env.REACT_APP_ROLE_ID_1 // Admin
export const roleId2 = process.env.REACT_APP_ROLE_ID_2 // Customer Support Executive
export const roleId3 = process.env.REACT_APP_ROLE_ID_3 // Service center 

export const roleArray = [roleId1,roleId2,roleId3]
